import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { EventsService } from './../../../../shared/services/events/events.service';
import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { UtilService } from '../../../../shared/services';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-pre-approve-banner',
  templateUrl: './pre-approve-banner.component.html',
  styleUrls: ['./pre-approve-banner.component.scss']
})
export class PreApproveBannerComponent implements OnInit {

  public isMobile: any;
  public fundraiserLink: string;
  public userData;
  isLoggedIn;
  Difference_In_Days;
  @Input() fundraiser;

  constructor(
    public utilService: UtilService,
    @Inject(DOCUMENT) private document: any,
    private eventsService: EventsService,
    private variablesService: VariablesService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.fundraiserLink = `${this.utilService.domain_details.domain_url}/fundraiser/${this.fundraiser?.custom_tag}`;
    this.checkUserLogin();
    // const creation_date = this.fundraiser.submitted_at ? this.fundraiser.submitted_at : this.fundraiser.creation_date;
    // const Difference_In_Time = new Date().getTime() - new Date(this.utilService.getDateInIos(creation_date)).getTime();
    const Difference_In_Time = new Date().getTime() - new Date(this.utilService.getDateInIos(this.fundraiser?.creation_date)).getTime();
    this.Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  }

  copyLink() {
    /* Get the text field */
    const copyText = this.fundraiserLink;
    const textArea = this.document.createElement('textarea');
    textArea.value = copyText;
    this.document.body.appendChild(textArea);
    textArea.select();
    this.document.execCommand('Copy');
    textArea.remove();
    alert('Copied the link: ' + copyText);
  }

  completeVerification() {
    const payload = {
      'eventName': 'skip_to_manage_dashboard',
      'event_type': 'campaign',
      'event_type_id': this.fundraiser?.id
    };
    this.eventsService.sendSystemEvent(payload).subscribe(
      () => {
        this.redirectToManageCamapaign();
      },
      (err) => {
        this.redirectToManageCamapaign();
      }
    );
  }

  private redirectToManageCamapaign() {
    const url = environment.manage_domain + '/manage/' + this.variablesService.fundraiser?.id + '/dashboard';
    this.utilService.nativeNavigation(url);
  }

  /**Check if logged in user is the owner
   * of the campaign then redirect to manage fundraiser
   */
  isCampaigner() {
    let isCampaigner = false;
    if (this.variablesService.fundraiser && this.userData) {
      if (this.userData.id === this.variablesService.fundraiser?.creator_entity_details_id ||
        this.userData.id === this.variablesService.fundraiser?.entity_details_id) {
        isCampaigner = true;
      }
    }
    return isCampaigner;
  }

  checkUserLogin() {
    this.utilService.isLoggedIn.subscribe((res) => {
      this.isLoggedIn = res;
      if (res === true) {
        this.onLoggedInUser();
      }
    });
  }

  onLoggedInUser() {
    this.variablesService.userData.subscribe({
      next: (res) => {
        this.userData = res;
      }
    });
  }

}
